module.exports = __webpack_public_path__ + "img/dohsc1.c01d12d2.png";